import React, { Fragment, useEffect, useState } from 'react';
import VideoPlayer from '../videoplayer/Player';
import { ShareAltOutlined } from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';
import { getCoursesService } from '../services/detailsService';
import { useSelector } from 'react-redux';
import { openNotificationInToast, SpinLoader } from '../utilities';
import ReadMore from '../components/ReadMore';
import EmptyAlert from '../components/EmptyAlert';
import { isMobile } from 'react-device-detect';
import Img from '../components/Img';
import { DefaultProfileIcon } from '../utilities/resources';
import { Button } from 'antd';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ExpertsBottomSheet from '../components/ExpertsBottomSheet';
import ExpertsTooltip from '../components/ExpertsTooltip';
import MetaDecorators from '../components/MetaDecorators';

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  initialSlide: 0,
  slidesToShow: 2.6,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      },
    },
  ],
};

function VideoLanding(props) {
  const { domainDetails } = useSelector((state) => state.listings);
  const [cmeDetails, setCmeDetails] = useState({});
  const [chapterDetails, setChapterDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState('');
  const [visible, setVisible] = useState(false);
  const { courseSlug, moduleId, chapterId } = useParams();

  const history = useHistory();
  useEffect(() => {
    setApiError('');
    getCoursesService(courseSlug, true)
      .then((response) => {
        setCmeDetails(response);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.message) {
          setApiError(error.response.data.message);
        }
        setLoading(false);
      });
  }, [courseSlug]);

  useEffect(() => {
    if (cmeDetails.courseDetails) {
      let chapterDet = null;
      if (chapterId) {
        cmeDetails.courseDetails.modules.forEach((module) => {
          module.userChapterDetails.forEach((chapter) => {
            if (chapter.id == chapterId) {
              chapterDet = chapter;
            }
          });
        });
      } else {
        let allWebinars = [];
        cmeDetails.courseDetails.modules.forEach((module) => {
          module.userChapterDetails.forEach((chapter) => {
            if (chapter.isWebinar) {
              allWebinars.push(chapter);
            }
          });
        });
        chapterDet =
          allWebinars.length > 0
            ? allWebinars[0]
            : cmeDetails.courseDetails.modules[0] && cmeDetails.courseDetails.modules[0].userChapterDetails && cmeDetails.courseDetails.modules[0].userChapterDetails.length > 0
            ? cmeDetails.courseDetails.modules[0].userChapterDetails[0]
            : null;
      }
      setChapterDetails(chapterDet);
    }
  }, [cmeDetails.courseDetails, chapterId]);

  const handleShare = (webinar) => {
    navigator.clipboard.writeText(window.location.href);
    openNotificationInToast('success', 'Link Copied!', 'The link has been copied to your clipboard!');
  };

  return loading ? (
    <div className='loader'>
      <SpinLoader />
    </div>
  ) : apiError !== '' ? (
    <div style={{ textAlign: 'center' }}>
      <EmptyAlert message={apiError} />
      <Button type='primary' onClick={() => history.goBack()} style={{ marginBottom: 40 }}>
        Go back
      </Button>
    </div>
  ) : chapterDetails ? (
    <Fragment>
      <MetaDecorators />
      <div>
        <VideoPlayer courseDetails={cmeDetails.courseDetails} chapterDetails={chapterDetails} videoUrl={chapterDetails.contentUrl} />
      </div>
      <div>
        <div className='wrapper'>
          <section className='detailsGrid'>
            <article>
              <h3>{chapterDetails.name}</h3>
              <ul>
                {cmeDetails.courseDetails.courseSpecialityList.map((speciality) => {
                  return <li key={speciality.speciality.id}>{speciality.speciality.name}</li>;
                })}
                <li>{chapterDetails.durationStr}</li>
              </ul>
            </article>
            <button onClick={handleShare} className='outlinedButtonBlue'>
              <ShareAltOutlined />
              Share
            </button>
          </section>
          <div className='divider' />
          <section className='detailsGrid detailsGridItems'>
            <div className='experts'>
              <Slider {...settings} className='slickArrows'>
                {chapterDetails.chapterExperts.map((expert) => {
                  return (
                    <div key={expert.id} className='expertsBox' onClick={() => setVisible(true)}>
                      <div className='expertsDp' onClick={() => setVisible(true)}>
                        <Img src={expert.profilePic} defaultSrc={DefaultProfileIcon} alt='' />
                      </div>
                      <div className='expertsDetails'>
                        <h4>{expert.name}</h4>
                        <p>{expert.qualification}</p>
                      </div>
                      <ExpertsTooltip name={expert.name} qualification={expert.qualification} location={expert.location} bio={expert.bio} />
                      {isMobile && (
                        <ExpertsBottomSheet
                          visible={visible}
                          setVisible={setVisible}
                          name={expert.name}
                          profilePic={expert.profilePic}
                          qualification={expert.qualification}
                          location={expert.location}
                          bio={expert.bio}
                        />
                      )}
                    </div>
                  );
                })}
              </Slider>
            </div>
            <div className='organizations'>
              <img src={domainDetails.image} alt='' />
            </div>
          </section>
          <div className='divider' />
          <section id='aboutCourse'>
            <h3>About the course</h3>
            <div>
              <ReadMore charLimit={isMobile ? 150 : 400} className={'ocLiveDescription'} content={cmeDetails.courseDetails.description} showAsHTML={true} />
            </div>
          </section>
        </div>
      </div>
    </Fragment>
  ) : null;
}

export default VideoLanding;
